<template>
   <li :class="{ 'active': routeName.startsWith('clients_')}" class="dropdown">
        <router-link v-if="newClients" class="dropdown-toggle" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false" :to="{name: 'clients_list'}">Cadastros 
          <span v-if="newClients" class="bell-badge">{{ newClients }}</span> 
        </router-link>
        <router-link v-else class="dropdown-toggle" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false" :to="{name: 'clients_list'}">Cadastros 
        </router-link>

        <ul class="dropdown-menu">
          <li class="dropdown-header">Filtros:</li>
          <li>
              <router-link :to="{name: 'clients_list', query: {period: 6}}">Hoje</router-link>
              <router-link :to="{name: 'clients_list', query: {period: 5}}">Ontem</router-link>
          </li>
          <template v-if="recentClients && recentClients.length > 0">
              <li role="separator" class="divider"></li>
              <li class="dropdown-header">Acessados recentemente:</li>
              <li v-for="(c, i) in recentClients" :key="i">
              <router-link :to="{ name: 'clients_details', params: { clientId: c.id }}" class="font-12">
                  <span style="margin: 0 5px 0 -10px; 
                    display: inline-block;" 
                    class="font-8 label" 
                    :class="{
                      'label-default': !c.status, 'label-warning': c.status == 0 && c.active == 1, 'label-danger': c.status == 2 || c.active == 0, 'label-success': c.status == 1 && c.active == 1
                      }">
                      &nbsp;
                  </span> {{ c.name }}
              </router-link>
              </li>
          </template>
        </ul>
    </li>
</template>

<script>
  import { mapState, mapActions } from 'vuex'
  export default {
    computed: {
      routeName () {
        return this.$route.name || ''
      },
      ...mapState({
        newClients: state => state.newClients,
        recentClients: state => state.recentClients,
        user: state => state.user
      })
    },
    mounted () {
      this.listenEvents()
      this.getNewClientsNotifications()
    },
    methods: {
      getNewClientsNotifications () {
        this.$http.get(`company_clients/count/${this.user.company.id}`)
        .then((response) => {
          this.changeNewClients(response.data.count)
        })
      },
      changeClientRegistred (e) {
        if (e) this.changeNewClients(e)
      },
      listenEvents () {
        window.Channel.listen('.App\\Events\\AdminClientAddingViaApp', (e) => {
          this.changeClientRegistred(e.quantity)
        })
        window.Channel.listen('.App\\Events\\SendUpdateUiAfterReleasing', (e) => {
          this.changeNewClients(e.quantity)
        })
      },
      ...mapActions(['changeNewClients'])
    }
}
</script>



// WEBPACK FOOTER //
// RegistrationsMenu.vue?40c76a6f